module.exports = __webpack_public_path__ + "static/media/kohli-lamborgini.31d3f6a5.png";